import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';

import useAxios from '../../hooks/useAxios';
import { getNoticeGroup } from '../../api/boardNotice.api';
import Loader from '../Loader';
import ErrorResponse from '../ErrorResponse';

interface IProps {
  groupDetailVisible: boolean;
  setGroupDetailVisible: Function;
  getGroupName: Function;
  noticeCode: number | undefined;
}

const SelectGroupModal: FC<IProps> = ({
  groupDetailVisible,
  setGroupDetailVisible,
  getGroupName,
  noticeCode,
}) => {
  const { t } = useTranslation();
  const { data, isLoading, error, execute } = useAxios<any>();

  useEffect(() => {
    if (noticeCode) {
      execute(getNoticeGroup(noticeCode));
    }
  }, [noticeCode]);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Modal
        title={t('board.notice.title3')}
        visible={groupDetailVisible}
        onCancel={() => setGroupDetailVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setGroupDetailVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div>
          <table className="table table-inside">
            <tbody>
              <tr>
                <th>{t('board.notice.column1')}</th>
              </tr>
              {data?.data.map((campusCode: any) => (
                <tr>
                  <td>{getGroupName(campusCode)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    </>
  );
};

export default SelectGroupModal;
